import createReactComponent from '../createReactComponent';
export default createReactComponent('file-import', 'IconFileImport', [
  ['path', { d: 'M14 3v4a1 1 0 0 0 1 1h4', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3',
      key: 'svg-1',
    },
  ],
]);
